import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFilteredCampaigns } from './campaigns-filter/campaigns-filter.state';
import {
    getCampaignsReportsStats,
    editCampaignReportsStats,
    getCampaigns,
} from './campaigns.state';

export const withCampaigns = connect(
    state => ({
        campaigns: getCampaigns(state),
        filteredCampaigns: getFilteredCampaigns(state),
    }),
    dispatch => bindActionCreators({
        getCampaignsReportsStats,
        editCampaignReportsStats,
    }, dispatch),
);
